import memoize from 'lodash/memoize'

const POLL_COUNT = 10
const POLL_TIMER = 5

const loadScript = (src: string, globalName: string, tagId?: string | null) => {
    if (typeof document === 'undefined') {
        return Promise.reject(new Error('document undefined'))
    }

    const script = document.createElement('script')

    script.src = src
    script.async = true

    if (tagId) {
        script.id = tagId
    }

    return new Promise((resolve, reject) => {
        let pollCount = 0

        function poll() {
            if ((window as any)[globalName]) {
                resolve((window as any)[globalName])
            } else if (pollCount > POLL_COUNT) {
                reject(new Error(`Timed out waiting for window.${globalName}`))
            } else {
                pollCount++
                setTimeout(poll, POLL_TIMER)
            }
        }

        script.onload = poll

        script.onerror = evt => {
            const error = new Error(JSON.stringify(evt))

            ;(error as any).scriptGlobalName = globalName
            resolve(error)
        }

        if (document.body) {
            document.body.appendChild(script)
        }
    })
}

export default memoize(
    loadScript,
    (arg1, arg2, arg3) => `${arg1}${arg2}${arg3}`,
)
